// extracted by mini-css-extract-plugin
module.exports = {"root":"ForgotPasswordForm_root__2W6qz","form":"ForgotPasswordForm_form__1r7Nv","button":"ForgotPasswordForm_button__-VMOm"};